import React, { useState, useEffect } from "react";

import backgroundImage from "../assets/img/background_home.png";
import Navbar from "../../navbar_and_footer/Navbar";
import Footer from "../../navbar_and_footer/Footer";
import httpClient from "../../../utils/httpClient";
import scrollGif from "../assets/img/scroll.gif";
import contactGif from "../assets/img/contact.gif";

import { SpinnerInfinity } from "spinners-react";

import Modal from "react-modal";

import Datepicker from "tailwind-datepicker-react";

export default function Homepage() {
  const [showGif, setShowGif] = useState(true);
  const [name, setName] = useState(null);
  const [email, setEmail] = useState(null);
  const [phone, setPhone] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showMessage, setShowMessage] = useState(false); // Control final message display
  const [isFading, setIsFading] = useState(false); // Control for fade animation

  const [isLoading, setIsLoading] = useState(false);

  const [isShareDisable, setIsShareDisable] = useState(true);

  const [show, setShow] = useState(false);
  const handleChange = (selectedDate) => {
    setSelectedDate(selectedDate);
  };
  const handleClose = (state) => {
    setShow(state);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setIsSubmitted(false);
    setShowMessage(false); // Reset message state
    setIsFading(false); // Reset fade state when closing modal
    window.location.reload();
  };

  const handleButtonClick = async () => {
    let booking = {
      name: name,
      email: email,
      phone: phone,
      date: selectedDate,
    };

    setIsLoading(true);
    await httpClient
      .post(`/v1/bookings`, booking)
      .then((res) => {
        console.log(res);
      })
      .catch((err) => console.error(err))
      .finally(() => {
        setIsModalOpen(true);
        setIsLoading(false);
      });
  };

  const handleScroll = () => {
    if (window.scrollY > 150) {
      setShowGif(false);
    } else {
      setShowGif(true);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <main>
        <div className=""></div>
        <Navbar transparent></Navbar>
        <div
          className="relative pt-16 pb-32 flex content-center items-center justify-center"
          style={{
            minHeight: "100vh",
          }}
        >
          <div
            className="absolute top-0 w-full h-full bg-center bg-cover"
            style={{
              backgroundImage: `url(${backgroundImage})`,
            }}
          >
            <span
              id="blackOverlay"
              className="w-full h-full absolute opacity-25 bg-black"
            ></span>
          </div>
          <div className="container relative mx-auto">
            <div className="flex flex-wrap items-center justify-end">
              <div className="w-full lg:w-6/12 px-4 text-right">
                <div className="pr-12">
                  <h1 className="text-white font-semibold text-5xl">
                    Share your memories with loved ones.
                  </h1>

                  <p
                    className="mt-4 text-lg text-gray-300"
                    style={{ marginTop: "10px", paddingTop: "20px" }}
                  >
                    {/* <DonateButton></DonateButton> */}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div
            className="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden"
            style={{ height: "70px" }}
          >
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="text-white fill-current"
                points="2560 0 2560 110 0 100"
                stroke="none"
              ></polygon>
            </svg>
          </div>
        </div>

        <section className="pb-20 mt-0" style={{ backgroundColor: "#ffffff" }}>
          <div className="container mx-auto px-4 justify-center flex flex-col align-middle">
            <div className="flex flex-wrap items-center justify-center mt-24">
              <form>
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-gray-700 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Name
                  </label>
                  <input
                    type="text"
                    onChange={(e) => {
                      setName(e.target.value);
                    }}
                    className="border-0 px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
                    placeholder="Popescu Andrei"
                    style={{ transition: "all .15s ease" }}
                  />
                </div>
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-gray-700 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Email
                  </label>
                  <input
                    type="email"
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                    className="border-0 px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
                    placeholder="example@google.com"
                    style={{ transition: "all .15s ease" }}
                  />
                </div>
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-gray-700 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Phone number
                  </label>
                  <input
                    type="text"
                    onChange={(e) => {
                      setPhone(e.target.value);
                    }}
                    className="border-0 px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
                    placeholder="0723957271"
                  />
                </div>
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-gray-700 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Event date
                  </label>
                  <Datepicker
                    options={{
                      autoHide: true,
                      todayBtn: true,
                      clearBtn: true,
                      theme: {
                        // background: "bg-gray-100", // Background color using Tailwind classes
                        todayBtn:
                          "bg-gray-900 text-white active:bg-gray-700 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1", // Button styles
                        // clearBtn: "bg-red-500 hover:bg-red-700 text-white", // Clear button styles
                        icons: "", // Custom icon classes
                        text: "text-gray-900 text-sm placeholder-gray-400 text-gray-700", // Text color
                        // "border-0 px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:ring ",
                        input:
                          "shadow border-0 focus:outline-none focus:ring text-sm placeholder-gray-400 text-gray-700",
                        // Input field styles
                        inputIcon: "text-gray-900", // Input icon styles
                      },
                    }}
                    onChange={handleChange}
                    show={show}
                    setShow={handleClose}
                  />
                </div>
                <div className="text-center mt-6">
                  <button
                    onClick={handleButtonClick}
                    className="bg-gray-900 flex items-center justify-center align-middle text-white active:bg-gray-700 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full"
                    type="button"
                    style={{ transition: "all .15s ease" }}
                  >
                    {isLoading ? (
                      <SpinnerInfinity
                        enabled={true}
                        secondaryColor="rgba(255,255,255, 1)"
                      />
                    ) : (
                      "Book"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>

        {/* The GIF at the bottom */}
        {showGif && (
          <div className="fixed bottom-0 left-0 right-0 flex justify-center">
            <img src={scrollGif} alt="Scroll down indicator" className="h-24" />
          </div>
        )}
        <Modal
          isOpen={isModalOpen}
          onRequestClose={handleCloseModal}
          className="flex justify-center items-center bg-white p-6 rounded-lg shadow-md w-full sm:w-3/4 md:w-2/3 lg:w-1/2 xl:w-1/3 max-w-screen-md mx-4 md:mx-auto"
          overlayClassName="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center"
          ariaHideApp={false}
        >
          <div>
            <span className="text-xl font-bold  align-middle items-center justify-center">
              Your request has been succesfuly submited, our team will contact
              you soon
            </span>
            <img src={contactGif} alt="" />
          </div>
        </Modal>
      </main>
      <Footer></Footer>
    </>
  );
}
